import React from "react";
import { Form, Input, Button, Space, message, Card, Typography } from "antd";
import {
  EmailRounded,
  HomeWorkRounded,
  LocalPhoneRounded,
  PersonRounded,
  SortRounded,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next"; // ✅ import i18n hook
import { authenticationService } from "../../app/services";
import AvatarUploader from "./AvatarUploader";

const { Title } = Typography;

const ProfileForm = ({ profile, onProfileUpdated }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation(); // ✅ translation hook

  const onFinish = async (values) => {
    try {
      const updated = await authenticationService.updateUserProfile(values);
      message.success(t("ProfileForm.update_success"));
      form.setFieldsValue(updated);
      onProfileUpdated(updated);
    } catch (error) {
      message.error(t("ProfileForm.update_fail"));
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <Card
        style={{
          maxWidth: 800,
          margin: "0 auto",
          borderRadius: 12,
          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
          textAlign: "center",
          padding: "32px",
        }}
      >
        <Title level={3} style={{ marginBottom: 24 }}>
          {t("ProfileForm.title")}
        </Title>

        {/* Avatar centered at the top */}
        <div style={{ marginBottom: 24 }}>
          <AvatarUploader
            profile={profile}
            isCompany={profile?.type === "Pro"}
            onProfileUpdated={onProfileUpdated}
          />
        </div>

        <Form
          form={form}
          layout="vertical"
          initialValues={profile}
          onFinish={onFinish}
          style={{ textAlign: "left" }}
        >
          <Form.Item
            name="username"
            label={t("ProfileForm.username")}
            rules={[{ required: true, message: t("ProfileForm.username_required") }]}
          >
            <Input
              prefix={<PersonRounded />}
              placeholder={t("ProfileForm.username_placeholder")}
            />
          </Form.Item>

          <Form.Item
            name="name"
            label={t("ProfileForm.name")}
            rules={[{ required: true, message: t("ProfileForm.name_required") }]}
          >
            <Input
              prefix={<SortRounded />}
              placeholder={t("ProfileForm.name_placeholder")}
            />
          </Form.Item>

          <Form.Item
            name="address"
            label={t("ProfileForm.address")}
            rules={[{ required: true, message: t("ProfileForm.address_required") }]}
          >
            <Input
              prefix={<HomeWorkRounded />}
              placeholder={t("ProfileForm.address_placeholder")}
            />
          </Form.Item>

          <Form.Item
            name="email"
            label={t("ProfileForm.email")}
            rules={[
              { required: true, message: t("ProfileForm.email_required") },
              { type: "email", message: t("ProfileForm.email_invalid") },
            ]}
          >
            <Input
              prefix={<EmailRounded />}
              placeholder={t("ProfileForm.email_placeholder")}
            />
          </Form.Item>

          <Form.Item
            name="phonenumber"
            label={t("ProfileForm.phone")}
            rules={[
              { required: true, message: t("ProfileForm.phone_required") },
            ]}
          >
            <Input
              prefix={<LocalPhoneRounded />}
              placeholder={t("ProfileForm.phone_placeholder")}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button htmlType="submit" type="primary">
                {t("ProfileForm.update_button")}
              </Button>
              <Button onClick={() => form.resetFields()}>
                {t("ProfileForm.reset_button")}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ProfileForm;
